import React from 'react';

function ProtectedRoute({ children }) {
  const token = window.localStorage.getItem('token') || 
    document.cookie.split('; ').find(r => r.startsWith('token='))?.split('=')[1];
  
  if (!token || token === 'null' || token === 'undefined' || token === '') {
    window.location.href = '/';
    return null;
  }
  return children;
}

export default ProtectedRoute;
